import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { string } from 'prop-types';

import css from './ListingPage.module.css';
import ListingField from './ListingField';


const SectionSuccessFactors = props => {
  const {
    hasCompletedAssessment,
    isReportAvailable,
    briefingAndDebriefing
  } = props;

  return (
    <div className={css.sectionDescription}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="ListingPage.successFactors" />
      </h2>
      <ListingField
        className={css.questionField}
        id="ListingPage.hasCompletedAssessment"
        value={hasCompletedAssessment}
      />
      <ListingField
        className={css.questionField}
        id="ListingPage.isReportAvailable"
        value={isReportAvailable}
      />
      <ListingField
        className={css.questionField}
        id="ListingPage.briefingAndDebriefing"
        value={briefingAndDebriefing}
      />
    </div>
  );
};

SectionSuccessFactors.propTypes = {
  hasCompletedAssessment: string,
  isReportAvailable: string,
  briefingAndDebriefing: string,
};

export default SectionSuccessFactors;
